import React from "react"
import { useTranslation } from "react-i18next"
import TaskStatusGroup from "@/features/tasks/components/task-status-group/task-status-group.tsx"
import { type CurrentTasksListProps } from "@/features/tasks/components/tasks-lists/tasks-list-current.tsx"
import { DONE_GREEN } from "@/utils/constants/colors-constants.ts"

export const TasksListDone: React.FC<CurrentTasksListProps> = ({
  filteredTasks,
}) => {
  const { t } = useTranslation()

  return (
    <>
      {filteredTasks.doneTasks.length > 0 && (
        <TaskStatusGroup
          tasks={filteredTasks.doneTasks}
          title={t("DONE")}
          backgroundColor={DONE_GREEN}
        />
      )}
    </>
  )
}
